













import { Component, Vue } from 'vue-property-decorator'

/**
 * @title  自定义动作
 * @desc 头部添加自定义内容。
 */
@Component
export default class ExtraExample extends Vue {
}
